var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-onboarding',[_c('recovery',{attrs:{"onboarding":""},on:{"confirm":_vm.confirm,"goLogin":_vm.goLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }